import Login from "../Pages/Login/Login";

const PublicRoutes = {
  path: "/",
  element: <Login />,
};

export default PublicRoutes;
